export default {
    FETCH_PAYMENTS_AND_UNALLOCATED_DOCUMENTS_COUNT: "fetchPaymentsAndUnallocatedDocumentsCount"
}